// Top nav zone, after Photon's TopNavBar (Figma frame 5953:2401 / rebrand
// 6667:71139): brand block, timestamp island, transport island, level meter
// island (absorbs the width slack, as in the app), Bypass. The meter canvas
// is driven by the host (ui/meter.ts LevelMeterCanvas).
import { html } from 'lit';
import type { TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { brandingIcon, logoMark, pauseIcon, playIcon, seekBackIcon, seekFwdIcon, wordmark } from './icons';
import { formatTimecode } from '@/state/time';

export interface NavProps {
  isPlaying: boolean;
  currentTimeS: number;
  durationS: number;
  transportDisabled: boolean;
  bypass: boolean;
  pulse: boolean;   // advertise interactivity until the first play
}

export interface NavCallbacks {
  onSeekStart: () => void;
  onTogglePlay: () => void;
  onSeekEnd: () => void;
  onToggleBypass: () => void;
}

export function renderNav(p: NavProps, cb: NavCallbacks): TemplateResult {
  const showPulse = p.pulse && !p.isPlaying && !p.transportDisabled;
  return html`
    <div class="nav">
      <div class="brand" aria-label="Photon">${logoMark}${wordmark}</div>
      <div class="island timestamp" aria-hidden="true">
        <span class="timecode">${formatTimecode(p.currentTimeS)}</span>
        <span class="timecode duration">&nbsp;/ ${formatTimecode(p.durationS)}</span>
      </div>
      <div class="island transport">
        <button
          class="island-btn"
          type="button"
          aria-label="Seek to start"
          ?disabled=${p.transportDisabled}
          @click=${cb.onSeekStart}
        >${seekBackIcon}</button>
        <button
          class=${classMap({ 'island-btn': true, 'play-btn': true, active: p.isPlaying, pulse: showPulse })}
          type="button"
          aria-label=${p.isPlaying ? 'Pause demo' : 'Play demo'}
          aria-pressed=${p.isPlaying ? 'true' : 'false'}
          ?disabled=${p.transportDisabled}
          @click=${cb.onTogglePlay}
        >${p.isPlaying ? pauseIcon : playIcon}</button>
        <button
          class="island-btn"
          type="button"
          aria-label="Seek to end"
          ?disabled=${p.transportDisabled}
          @click=${cb.onSeekEnd}
        >${seekFwdIcon}</button>
      </div>
      <div class="island meter" aria-hidden="true">
        <canvas class="meter"></canvas>
      </div>
      <div class="island">
        <button
          class=${classMap({ 'island-btn': true, 'text-btn': true, active: p.bypass })}
          type="button"
          aria-pressed=${p.bypass ? 'true' : 'false'}
          ?disabled=${p.transportDisabled}
          @click=${cb.onToggleBypass}
        >Bypass</button>
      </div>
      <span class="branding" aria-hidden="true">${brandingIcon}</span>
    </div>
  `;
}
